/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProvinceCreateModel } from '../../models/province-create-model';
import { ProvinceModel } from '../../models/province-model';

export interface PostApiProvinceV1Create$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * The province to create.
     */
    body?: ProvinceCreateModel
}

export function postApiProvinceV1Create$Json(http: HttpClient, rootUrl: string, params?: PostApiProvinceV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvinceModel>> {
  const rb = new RequestBuilder(rootUrl, postApiProvinceV1Create$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProvinceModel>;
    })
  );
}

postApiProvinceV1Create$Json.PATH = '/private/v1/provinces/create';
